import TabsErp from "../../../../../components/tabs/TabsErp";
import { useState } from "react";
import { ProdutosBodyContextProvider } from "../../contexts/ProdutosBodyContext";
import useProdutosBodyController from "../../controllers/ProdutosBodyController";
import { CustomButton, CustomDialogContent } from "../../styles/styles";
import { DialogActions } from "@material-ui/core";

const View = ({ setOpen, setLoading }) => {
  const { tabTitles, tabContents, handleSaveProductParams } =
    useProdutosBodyController(setLoading, setOpen);

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <CustomDialogContent style={{ overflowY: "hidden" }}>
        <TabsErp
          headers={tabTitles}
          tabIndex={tabIndex}
          children={tabContents}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
          contentClassName="ContentModalParameters"
          marginChildrenToTop={0}
        />
      </CustomDialogContent>
      <DialogActions>
        <CustomButton
          onClick={async () => await handleSaveProductParams()}
          label="Salvar"
          bgcolor="primary"
          hovercolor="orange"
        />
      </DialogActions>
    </>
  );
};

const ProdutosBody = ({ ...props }) => (
  <ProdutosBodyContextProvider>
    <View {...props} />
  </ProdutosBodyContextProvider>
);
export default ProdutosBody;
